import { useEffect, useState } from 'react'

import { getCountries } from '../../apis/common.apis'
import { orgSize, sectorData } from '../organisation/store'
import { getOrgList } from './api'
import { policyDropdown, reportPolicyOptions } from './store'

export const GetFilterDetails = (reportType?: string) => {
  const [countryList, setCountryList] = useState<any>()
  const [organisationList, setOrganisationList] = useState<any>()
  const getCountry = async () => {
    const data = await getCountries()
    const input = data.map((item: any) => ({
      ...item,
      id: item.code,
      country_name: item.name,
      country_code: item.code,
    }))
    setCountryList(input)
    return input
  }
  const handleCountry = async (search: any) => {
    const filteredCountries = countryList.filter(
      (item: any) =>
        !search ||
        item.country_name.toLowerCase().includes(search.toLowerCase())
    )
    const result = [
      {
        country_name: 'None',
        country_code: 'None',
        code: 'None',
        id: 'None',
        name: 'None',
      },
      ...filteredCountries,
    ]

    return result
  }
  const handleOrganisationList = async () => {
    const data = await getOrgList()
    const input = data.map((item: any) => ({
      ...item,
      id: item.id,
      org_name: item.name,
    }))
    setOrganisationList(input)
    return input
  }
  const getOrganisationList = async (search: any) => {
    const input = organisationList.filter(
      (item: any) =>
        !search || item.org_name.toLowerCase().includes(search.toLowerCase())
    )
    return input
  }
  const getWorkforceLocations = async (search: any) => {
    const locations = (countryList || []).map((item: any) => ({
      ...item,
      id: item.name,
      workforce_location: item.name,
    }))

    if (search) {
      return locations.filter((item: any) =>
        item.workforce_location.toLowerCase().includes(search.toLowerCase())
      )
    }

    return locations
  }

  const organisationSize = (search: any) => {
    let data = orgSize
    if (search) {
      data = orgSize.filter((item) =>
        item.label.toLowerCase().includes(search.toLowerCase())
      )
    }
    return data
  }
  const getReportPolicyOptions = (search: any) => {
    let data = reportPolicyOptions
    if (search) {
      data = reportPolicyOptions.filter((item) =>
        item.policy.toLowerCase().includes(search.toLowerCase())
      )
    }
    return data
  }
  const getSector = (search?: any) => {
    let data = sectorData
    if (search) {
      data = sectorData.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    }
    return data
  }
  const getTierData = (search?: string) => {
    const tierData = [
      {
        id: 'Diversity Mark Accredited',
        tier: 'Diversity Mark Accreditation',
        name: 'Diversity Mark Accreditation',
      },
      {
        id: 'Silver Accredited',
        tier: 'Silver Accreditation',
        name: 'Silver Accreditation',
      },
      {
        id: 'Gold Accredited',
        tier: 'Gold Accreditation',
        name: 'Gold Accreditation',
      },
      {
        id: 'None',
        tier: 'None',
        name: 'None',
      },
    ]

    let data = tierData

    if (search) {
      data = tierData.filter((item) =>
        item.tier.toLowerCase().includes(search.toLowerCase())
      )
    }

    return data
  }
  const getApplicationStatus = (search?: string) => {
    const options = [
      { id: 'in_progress', name: 'In Progress' },
      { id: 'submitted_by_applicant', name: 'Submitted By Applicant' },
      { id: 'submitted_to_panel', name: 'Submitted To Panel' },
      {
        id: 'assessed_refinement_required',
        name: 'Assessed Refinement Required',
      },
      { id: 'assessed_resubmission', name: 'Assessed Resubmission' },
      { id: 'assessed_approved', name: 'Assessed Approved' },
    ]

    if (search) {
      return options.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    }

    return options
  }
  const getUserStatus = (search?: string) => {
    const options = [
      { id: 'Active', name: 'Active' },
      { id: 'Inactive', name: 'Inactive' },
    ]

    if (search) {
      return options.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    }

    return options
  }
  const getActivityStatus = (search?: string) => {
    const options = [
      { id: 'Active', name: 'Active' },
      { id: 'Inactive', name: 'Inactive' },
      { id: 'Stalled', name: 'Stalled' },
    ]

    if (search) {
      return options.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    }

    return options
  }
  const getDraftStatus = (search?: string) => {
    const options = [
      { id: 'Draft', name: 'Draft' },
      { id: 'Submitted', name: 'Submitted' },
    ]

    if (search) {
      return options.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    }

    return options
  }
  const getApplicationType = (search?: string) => {
    const options = [
      { id: 'New Application', name: 'New Application' },
      { id: 'Renewal', name: 'Renewal' },
      { id: 'Resubmission', name: 'Resubmission' },
    ]

    if (search) {
      return options.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    }

    return options
  }

  useEffect(() => {
    getCountry()
    handleOrganisationList()
  }, [])
  const filters = [
    {
      name: ' Organisation Name',
      type: 'multi_select',
      getData: getOrganisationList,
      descId: 'id',
      desc: 'org_name',
      async: true,
      selectAll: true,
      isPrimary: true,
      slug: 'org_name',
      objectId: 'organisation_id',
    },
    {
      name: 'Accreditation Tier',
      type: 'multi_select',
      getData: getTierData,
      desc: 'name',
      descId: 'id',
      async: true,
      isPrimary: true,
      slug: 'stage',
      viewSearchInput: false,
      selectAll: true,
      objectId: 'stage',
    },
    {
      type: 'date',
      desc: 'givenDate',
      isPrimary: true,
      name: 'Filter By Date',
      slug: 'givenDate',
    },
    {
      name: 'Organisation Sector',
      type: 'multi_select',
      getData: getSector,
      desc: 'sector',
      descId: 'id',
      selectAll: true,
      async: true,
      isPrimary: true,
      slug: 'sector',
      objectId: 'sector',
    },
    {
      name: 'Organisation Size (Employees)',
      type: 'multi_select',
      getData: organisationSize,
      descId: 'name',
      desc: 'label',
      async: true,
      isPrimary: true,
      viewSearchInput: false,
      selectAll: true,
      slug: 'size',
      objectId: 'size',
    },
    {
      name: 'Declared Headcount',
      type: 'multi_select',
      getData: organisationSize,
      descId: 'id',
      desc: 'value',
      selectAll: true,
      viewSearchInput: false,
      async: true,
      isPrimary: true,
      slug: 'total',
      objectId: 'total',
    },

    {
      type: 'date_picker',
      selectRange: true,
      desc: 'fromDate',
      descSecondary: 'toDate',
      isPrimary: true,
      name: 'Join Date',
      slug: 'created_date',
    },

    {
      name: 'ED&I Strategy',
      type: 'multi_select',
      getData: getReportPolicyOptions,
      descId: 'id',
      desc: 'policy',
      async: true,
      isPrimary: true,
      viewSearchInput: false,
      selectAll: true,
      slug: 'policy',
      objectId: 'has_dei_strategy',
    },
    {
      desc: 'option',
      type: 'custom_search_select',
      descId: 'id',
      async: true,
      isPrimary: true,
      data: policyDropdown,
      name: 'Charter Signatory',
      slug: 'is_verified',
      objectId: 'is_verified',
    },
    {
      name: 'Country',
      type: 'multi_select',
      getData: handleCountry,
      descId: 'id',
      desc: 'country_name',
      async: true,
      selectAll: true,
      isPrimary: true,
      slug: 'country_code',
      objectId: 'country',
    },
    {
      name: 'Primary Workforce Location',
      type: 'multi_select',
      getData: getWorkforceLocations,
      descId: 'id',
      desc: 'workforce_location',
      async: true,
      selectAll: true,
      isPrimary: true,
      slug: 'workforce_location',
      objectId: 'workforce_location',
    },
    {
      name: 'Application Status',
      type: 'multi_select',
      getData: getApplicationStatus,
      descId: 'id',
      desc: 'name',
      async: true,
      selectAll: true,
      isPrimary: true,
      slug: 'application_status',
      objectId: 'application_status',
    },
    {
      name: 'User Status',
      type: 'multi_select',
      getData: getUserStatus,
      descId: 'id',
      desc: 'name',
      async: true,
      selectAll: true,
      isPrimary: true,
      slug: 'user_status',
      objectId: 'user_status',
    },
    {
      name: 'Activity Status',
      type: 'multi_select',
      getData: getActivityStatus,
      descId: 'id',
      desc: 'name',
      async: true,
      selectAll: true,
      isPrimary: true,
      slug: 'activity_status',
      objectId: 'activity_status',
    },
    {
      name: 'Draft / Submitted',
      type: 'multi_select',
      getData: getDraftStatus,
      descId: 'id',
      desc: 'name',
      async: true,
      selectAll: true,
      isPrimary: true,
      slug: 'draft_status',
      objectId: 'draft_status',
    },
    {
      name: 'Application Type',
      type: 'multi_select',
      getData: getApplicationType,
      descId: 'id',
      desc: 'name',
      async: true,
      selectAll: true,
      isPrimary: true,
      slug: 'application_type',
      objectId: 'application_type',
    },
    {
      type: 'date_picker',
      selectRange: true,
      desc: 'last_login_from',
      descSecondary: 'last_login_to',
      isPrimary: true,
      name: 'Last Login',
      slug: 'last_login',
    },
    // {
    //   desc: 'is_test_organisation',
    //   type: 'custom_search_select',
    //   descId: 'id',
    //   async: true,
    //   isPrimary: true,
    //   data: policyDropdown,
    //   name: 'Test Organisation',
    //   slug: 'is_test_organisation',
    //   objectId: 'is_test_organisation',
    // }, HIDDEN IN UAT

    // {
    //   name: 'Postal Code',
    //   type: 'text_field',
    //   slug: 'pin_code',
    //   objectId: 'pin_code',
    //   isPrimary: true,
    //   descId: 'id',
    //   desc: 'pin_code',
    // },
    // {
    //   name: 'State',
    //   type: 'text_field',
    //   slug: 'state',
    //   objectId: 'state',
    //   isPrimary: true,
    //   descId: 'id',
    //   desc: 'state',
    // },
    // {
    //   name: 'City',
    //   type: 'text_field',
    //   slug: 'city',
    //   objectId: 'city',
    //   isPrimary: true,
    //   descId: 'id',
    //   desc: 'city',
    // },
  ]
  if (reportType === 'accreditation-deadline-report') {
    const attentionOptions = [
      { id: 'progress_report_due', name: 'Progress Report Due' },
      { id: 'progress_report_overdue', name: 'Progress Report Overdue' },
      {
        id: 'accreditation_expiring_soon',
        name: 'Accreditation Expiring Soon',
      },
      { id: 'renewal_due', name: 'Renewal Due' },
    ]
    return [
      filters[0],
      {
        ...filters[1],
        name: 'Current Accreditation Tier',
        getData: async (search?: string) =>
          [
            { id: 'accreditation', name: 'Bronze' },
            { id: 'silver', name: 'Silver' },
            { id: 'gold', name: 'Gold' },
          ].filter(
            (item) =>
              !search || item.name.toLowerCase().includes(search.toLowerCase())
          ),
      },
      {
        name: 'Attention Status',
        type: 'multi_select',
        getData: async (search?: string) =>
          attentionOptions.filter(
            (item) =>
              !search || item.name.toLowerCase().includes(search.toLowerCase())
          ),
        descId: 'id',
        desc: 'name',
        async: true,
        selectAll: true,
        isPrimary: true,
        slug: 'attention_status',
        objectId: 'attention_status',
      },
      {
        type: 'date_picker',
        selectRange: true,
        desc: 'fromDate',
        descSecondary: 'toDate',
        isPrimary: true,
        name: 'Deadline Date',
        slug: 'created_date',
      },
    ]
  }
  return filters
}
